import type { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = HttpBadStatusCodeError | UnknownError;

/**
 * @deprecated Будет удалено в рамках COMM-1094, когда будем отказываться от использования меты
 */
export type QueryKeyLegacy = [EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetMeta_Legacy];
/**
 * @deprecated Будет удалено в рамках COMM-1094, когда будем отказываться от использования меты
 */
export const getQueryKeyLegacy = (): QueryKeyLegacy => [
  EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetMeta_Legacy,
];

export type QueryKey = [EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetMeta];
export const getQueryKey = (): QueryKey => [EQueryKeys.CommercialSearchOffers__Desktop_V1_Filters_GetMeta];
